import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import NativeSelect, { NativeSelectProps } from '@material-ui/core/NativeSelect';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { endpoints } from '../../config';
import { IUserInfoState } from '../../types/UserInfo.types';
import axios from 'axios';
import { ILanguageStrings } from '../../utils/languages/languages';

const useStyles = makeStyles(() =>
  createStyles({
    textField: {
      borderRadius: 7,
      marginTop: 30,
      '& .MuiIcon-root': {
        color: '#a2a2a2'
      },
      '&.MuiTextField-root, &.MuiInput-root': {
        width: '100%',
        margin: 0
      }
    }
  })
);

interface UserInfoProps {
  previousStep: Function;
  nextStep: Function;
  handleChange: Function;
  companyKey: string;
  data: IUserInfoState;
  languageStrings: ILanguageStrings;
}

const TextFieldStyled: React.FC<TextFieldProps> = (props: TextFieldProps) => {
  const classes = useStyles();
  return (
    <TextField {...props} className={classes.textField}>
      {props.children}
    </TextField>
  );
};

const NativeSelectStyled: React.FC<NativeSelectProps> = (props: NativeSelectProps) => {
  const classes = useStyles();
  return (
    <NativeSelect {...props} className={classes.textField}>
      {props.children}
    </NativeSelect>
  );
};

export class UserInfo extends Component<UserInfoProps, {}> {
  state = {
    timezoneList: []
  };

  handleSubmit = () => {
    this.props.nextStep();
  };

  validInputs = () => {
    const { firstName, lastName, workPhone, timeZone } = this.props.data;
    const fields = Array.from([firstName, lastName, workPhone, timeZone]);
    return fields.every((field: string) => field.trim().length > 0);
  };

  onInputChange = (event: { target: { value: string } }, inputName: string): void => {
    this.props.handleChange('userInfo', inputName, this.validInputs)(event);
  };

  componentDidMount = async () => {
    try {
      const list: any = await axios(`${endpoints.Location}?companyKey=${this.props.companyKey}`);
      if (list && list.data.length > 0) {
        const timezoneList = list.data;
        this.setState({ timezoneList });
      }
    } catch (err) {
      return err;
    } finally {
    }
  };

  renderForm = () => {
    return (
      <Grid container item xs={5} alignItems="center" justifyContent="center" spacing={3} style={{ margin: '0 auto' }}>
        <Grid container item xs={12} alignItems="center" direction="row" spacing={3}>
          <Grid item xs={2}>
            <NativeSelectStyled
              onChange={event => this.onInputChange(event, 'salutation')}
              variant="outlined"
              data-testid="salutation"
              required
              value={this.props.data.salutation}
              fullWidth
            >
              {this.props.languageStrings.userInfo.salutation.map(({ label, value }, i) => (
                <option key={`salutation-${value}-${i}`} value={value}>
                  {label}
                </option>
              ))}
            </NativeSelectStyled>
          </Grid>

          <Grid item xs>
            <TextFieldStyled
              label={this.props.languageStrings.userInfo.firstName}
              id="firstName"
              required
              onChange={event => this.onInputChange(event, 'firstName')}
              variant="outlined"
              value={this.props.data.firstName}
            />
          </Grid>

          <Grid item xs>
            <TextFieldStyled
              size="medium"
              label={this.props.languageStrings.userInfo.lastName}
              id="lastName"
              required
              onChange={event => this.onInputChange(event, 'lastName')}
              variant="outlined"
              value={this.props.data.lastName}
            />
          </Grid>
        </Grid>

        <Grid container item xs={12} alignItems="center" direction="row" spacing={3}>
          <Grid item xs={12}>
            <TextFieldStyled
              size="medium"
              label={this.props.languageStrings.userInfo.workPhone}
              id="workPhone"
              required
              onChange={event => this.onInputChange(event, 'workPhone')}
              variant="outlined"
              value={this.props.data.workPhone}
            />
          </Grid>

          <Grid item xs={12}>
            <TextFieldStyled
              size="medium"
              label={this.props.languageStrings.userInfo.jobTitle}
              id="jobTitle"
              onChange={event => this.onInputChange(event, 'jobTitle')}
              variant="outlined"
              value={this.props.data.jobTitle}
            />
          </Grid>

          <Grid item xs={12}>
            <NativeSelectStyled
              onChange={event => this.onInputChange(event, 'timeZone')}
              fullWidth
              required
              variant="outlined"
              data-testid="timeZone"
              value={this.props.data.timeZone}
            >
              <option value="">{this.props.languageStrings.userInfo.timeZone}</option>
              {this.state.timezoneList &&
                this.state.timezoneList.length > 0 &&
                this.state.timezoneList.map((timezone: any, index) => {
                  return (
                    <option key={index} value={timezone.zoneid}>
                      {timezone.displayname}
                    </option>
                  );
                })}
            </NativeSelectStyled>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  render() {
    return (
      <div className="UserInfo">
        <div className="Wrapper">
          <Paper style={{ boxShadow: 'none' }}>
            <br />
            <br />
            <br />
            {this.renderForm()}
            <br />
            <br />
            <div className="Form-actions multiple">
              <Button variant="outlined" color="primary" onClick={() => this.props.previousStep()}>
                {this.props.languageStrings.userInfo.reStart}
              </Button>

              <Button
                disabled={!this.validInputs()}
                variant="contained"
                color="primary"
                onClick={() => this.handleSubmit()}
              >
                {this.props.languageStrings.continueButtonLabel}
              </Button>
            </div>
          </Paper>
        </div>
      </div>
    );
  }
}

export default UserInfo;
